module.exports = __webpack_public_path__ + "static/product.hbsq-5c3bc453d8e6d76fe54dd4e50f30f018.png";